import React from "react";
import type Highcharts from "highcharts";
import HighchartsComponent from "@ui/Highcharts";
import useOptions from "./useOptions";
import type { SelectedQuantity } from "../../useSelectedQuantities";
import type getSeries from "./getSeries";
import type { ActiveAnalysis } from "../../../../api/useActiveAnalysesStream";
import type { Project } from "../../../../api/useProjects";
import type { Source } from "../../../../api/useSources";

interface P {
  chartRef: React.RefObject<Highcharts.Chart>;
  analyses: ActiveAnalysis[];
  project: Project;
  selectedQuantities: SelectedQuantity[];
  source: Source;
  series: ReturnType<typeof getSeries>;
  timeZone: string;
}

const Amplitude = ({
  chartRef,
  analyses,
  project,
  source,
  selectedQuantities,
  series,
  timeZone,
}: P) => {
  const options = useOptions({
    chartRef,
    selectedQuantities,
    series,
    analyses,
    project,
    source,
    timeZone,
  });

  return (
    <HighchartsComponent
      name="Symptoms amplitude"
      ref={chartRef}
      options={options}
      selectablePoints
      timezone={timeZone}
    />
  );
};

export default React.memo(Amplitude);
